import React from "react";
import "./App.css";
import MainContent from "./pages/MainContent";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";

import { ThemeProvider } from "@mui/material/styles";
import CommunityPage from "./pages/CommunityPage";
import PostPage from "./pages/PostPage";
import ProfilePage from "./pages/ProfilePage";
import StocksPage from "./pages/StocksPage";
import SignInSignUpPage from "./pages/SignInSignUpPage";
import CreatePost from "./pages/CreatePost";
import CreateUserInfoPage from "./pages/CreateUserInfoPage";
import EditPhotos from "./pages/EditPhotos";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import CheckEmailPage from "./pages/CheckEmailPage";
import ForgotUsernamePage from "./pages/ForgotUsernamePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import { AuthProvider } from "./context/AuthContext";
import RouteTracker from "./context/RouteTracker";
import CreateCommunity from "./pages/CreateCommunity";
import CommunitiesPage from "./pages/CommunitiesPage";
import { PageProvider } from "./context/PageContext";
import ErrorBoundary from "./utils/ErrorBoundary";
import {
  ThemeProvider as CustomThemeProvider,
  useTheme,
} from "./components/ThemeContext";

import { DeviceProvider } from "./context/DeviceContext";
import { PositionProvider } from "./context/PositionContext";
import CreatePosition from "./pages/CreatePosition";
import OAuthCallbackPage from "./pages/OAuthCallbackPage";
import TermsPage from "./pages/TermsPage";
import TermsAcceptanceGuard from "./components/TermsAcceptanceGuard";

function App() {
  const { theme } = useTheme();
  return (
    <CustomThemeProvider>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <PageProvider>
            <DeviceProvider>
              <PositionProvider>
                <Router>
                  <RouteTracker />
                  <TermsAcceptanceGuard />
                  <div className="App">
                    <Routes>
                    <Route path="" element={<MainContent />} />
                    <Route path="/" element={<MainContent />} />
                    <Route
                      path="/c/:communityName"
                      element={<CommunityPage />}
                    />
                    <Route
                      path="/community/:communityName"
                      element={<CommunityPage />}
                    />
                    <Route
                      path="/community/:communityName/:postId"
                      element={<PostPage />}
                    />
                    <Route path="/s/:stockTicker" element={<StocksPage />} />
                    <Route path="/post/:postId" element={<PostPage />} />
                    <Route
                      path="/profile/:username"
                      element={<ProfilePage />}
                    />
                    <Route path="/u/:" element={<ProfilePage />} />
                    <Route path="/verify-email" element={<VerifyEmailPage />} />
                    <Route path="/check-email" element={<CheckEmailPage />} />
                    <Route path="/forgot-username" element={<ForgotUsernamePage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/signin" element={<SignInSignUpPage />} />
                    <Route path="/signup" element={<SignInSignUpPage />} />
                    <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/createPost" element={<CreatePost />} />
                    <Route
                      path="/createCommunity"
                      element={<CreateCommunity />}
                    />
                    <Route path="/createPosition" element={<CreatePosition />} />
                    <Route path="/communities" element={<CommunitiesPage />} />
                    <Route
                      path="/add-user-profile"
                      element={<CreateUserInfoPage />}
                    />
                    <Route path="/edit-photos" element={<EditPhotos />} />
                    <Route path="/add-new-photos" element={<EditPhotos />} />
                  </Routes>
                </div>
              </Router>
              </PositionProvider>
            </DeviceProvider>
          </PageProvider>
        </AuthProvider>
      </ThemeProvider>
    </CustomThemeProvider>
  );
}

export default App;
